import React, { useRef, useState } from 'react';
import { Upload, Loader2 } from 'lucide-react';
import axios from 'axios';
import { getToken } from '../lib/api';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Bouton d'upload d'image. Retourne l'URL via onUploaded.
 * Prêt à côté d'un input URL — l'utilisateur choisit URL ou upload.
 */
const ImageUpload = ({ onUploaded, size = 'md', label = 'Uploader', testId }) => {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const pick = () => fileRef.current?.click();

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setErr('');
    if (!file.type.startsWith('image/')) { setErr('Fichier non-image'); return; }
    if (file.size > 8 * 1024 * 1024) { setErr('> 8 Mo'); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await axios.post(`${API_URL}/api/admin/upload/image`, fd, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      const absUrl = data.url.startsWith('http') ? data.url : `${API_URL}${data.url}`;
      onUploaded?.(absUrl);
    } catch (e) {
      setErr(e.response?.data?.detail || 'Erreur upload');
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  const sizeCls = size === 'sm'
    ? 'px-2 py-1.5 text-xs'
    : 'px-3 py-2 text-sm';

  return (
    <>
      <button
        type="button"
        onClick={pick}
        disabled={busy}
        title={err || label}
        className={`flex items-center gap-1.5 rounded-lg bg-slate-900 hover:bg-slate-800 disabled:bg-slate-400 text-white font-semibold transition-colors ${sizeCls}`}
        data-testid={testId}
      >
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
        {size !== 'sm' && (busy ? 'Envoi…' : label)}
      </button>
      <input
        type="file"
        ref={fileRef}
        accept="image/*"
        onChange={onFile}
        className="hidden"
      />
      {err && <span className="text-xs text-red-600 ml-1">{err}</span>}
    </>
  );
};

export default ImageUpload;
